import { Box, Button, Grid, Paper } from '@material-ui/core';
import React, { Component } from 'react';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { HeaderBlock } from '../../components/header-block/HeaderBlock';
import ListableCard from '../../components/listable-card/ListableCard';
import { Loading } from '../../components/loading/Loading';
import PageContainer from '../../components/page-container/PageContainer';
import { DeleteModal } from '../../containers/delete-modal/DeleteModal';
import GenericPickerModal from '../../containers/generic-picker-modal/GenericPickerModal';
import { getCallScheduleTypeFilter, getCallScheduleTypeIds, postCallScheduleTypeFilter } from '../../state/actions/CallScheduleActions';
import styles from "./CallScheduleBlacklistPage.module.scss";
import HelpCard from '../../components/help-card/HelpCard';
import { withTranslation } from 'react-i18next';

class CallScheduleBlacklistPage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      loadingBlacklist: false,
      callScheduleModalOpen: false,
      deleteModalOpen: false,
      idsToDelete: []
    }
  }

  componentDidMount() {
    this.getCallScheduleTypeFilter()
  }

  getCallScheduleTypeFilter() {
    this.setState({
      loading: true, loadingBlacklist: true
    });

    this.props.getCallScheduleTypeFilter(() => {
      this.setState({
        loading: false,
      })

      this.props.getCallScheduleTypeIds(() => {
        this.setState({
          loadingBlacklist: false
        });
      });
    });
  }

  getCallScheduleTypesByIds(callScheduleTypeIds) {
    if (callScheduleTypeIds != null) {
      return callScheduleTypeIds.map(callScheduleTypeId => {
        const callScheduleType = this.props.callScheduleTypeIds[callScheduleTypeId];

        if (callScheduleType != null) {
          return { id: callScheduleType.Code, Name: callScheduleType.Name || callScheduleType.Code };
        }

        return {};
      });
    }

    return [];
  }

  handleCallScheduleSelection(items) {

    const values = (this.props.callScheduleTypeFilter != null ? Object.values(this.props.callScheduleTypeFilter) : []).concat(items)

    this.setState({ callScheduleModalOpen: false, loadingBlacklist: true })
    this.props.postCallScheduleTypeFilter(values, () => {
      this.setState({ loadingBlacklist: false })
    });
  }

  handleCallScheduleDeletion(items) {
    const itemIds = items.map(item => item.id);
    const values = (this.props.callScheduleTypeFilter != null ? Object.values(this.props.callScheduleTypeFilter) : []).filter(value => !itemIds.includes(value));

    this.setState({ loadingBlacklist: true, deleteModalOpen: false });
    this.props.postCallScheduleTypeFilter(values, () => {
      this.setState({ loadingBlacklist: false, idsToDelete: [] });
    });
  }

  getContentGrid() {
    const cards = [
      {
        add: this.props.t('common.add'),
        buttonAction: () => {
          this.setState({ callScheduleModalOpen: true })
        },
        handleDelete: (items) => {
          this.setState({ deleteModalOpen: true, idsToDelete: items })
        },
        isLoading: () => { return this.state.loadingBlacklist },
        title: this.props.t('call-schedule-blacklist.blacklisted-call-schedules'),
        emptyPlaceholder: this.props.t('call-schedule-blacklist.none-blacklisted'),
        data: this.getCallScheduleTypesByIds(this.props.callScheduleTypeFilter != null ? Object.values(this.props.callScheduleTypeFilter) : []),
        type: "call-schedule"
      },
    ];

    return (
      <div className={styles.contentGrid}>
        <Grid container spacing={3}>
          {cards.map(card => {
            if (card.type === "title") {
              return (
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <div className={styles.sectionHeader}>{card.title}</div>
                </Grid>
              );
            }

            return (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Paper>
                  <ListableCard
                    actionButton={[
                      <Button
                        onClick={card.buttonAction}
                        variant="outlined"
                        color="secondary"
                      >
                        {card.add}
                      </Button>
                    ]}
                    addLabel={card.add}
                    isLoading={card.isLoading()}
                    title={card.title}
                    emptyPlaceholder={card.emptyPlaceholder}
                    handleDelete={card.handleDelete}
                    data={card.data == null ? [] : card.data}
                  />
                </Paper>
              </Grid>
            );
          })}
        </Grid>
      </div>
    );
  }

  renderData() {
    return (
      this.state.loading ?
        <Loading /> :
        <Box>
          {this.getContentGrid()}
        </Box>
    )
  }

  render() {
    return (
      <Box>
        <HeaderBlock
          title={
            this.props.t('call-schedule-blacklist.call-schedule-blacklist')
          }
        />

        <DeleteModal
          handleCancel={() => {
            this.setState({ deleteModalOpen: false, idsToDelete: [] });
          }}
          handleDone={data => {
            this.handleCallScheduleDeletion(data);
          }}
          data={this.getCallScheduleTypesByIds(this.state.idsToDelete)}
          open={this.state.deleteModalOpen}
        />

        <GenericPickerModal
          handleCancel={() => this.setState({ callScheduleModalOpen: false })}
          handleDone={selectedProducts => this.handleCallScheduleSelection(selectedProducts)}
          open={this.state.callScheduleModalOpen}
          selected={
            this.props.callScheduleTypeFilter != null ? this.props.callScheduleTypeFilter : []
          }
          handleSelection={() => { }}
          getAllData={(callback) => this.props.getCallScheduleTypeIds(callback)}
          searchTitle={this.props.t('call-schedule-blacklist.search')}
          title={this.props.t('call-schedule-blacklist.call-schedule-ids')}
          data={Object.values(this.props.callScheduleTypeIds)}
          idField="Code"
          valueField="Name"
        />

        <HelpCard
          message={this.props.t('call-schedule-blacklist.help')}
        />

        <PageContainer hasHelp>
          {this.renderData()}
        </PageContainer>
      </Box>
    )
  }
}

const mapStateToProps = (state) => {
  const { callScheduleTypeIds } = state.CallScheduleReducer;
  const { callScheduleTypeFilter } = state.CallScheduleReducer;
  return { callScheduleTypeIds, callScheduleTypeFilter };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getCallScheduleTypeIds,
      getCallScheduleTypeFilter,
      postCallScheduleTypeFilter
    },
    dispatch
  );

const hoc = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(CallScheduleBlacklistPage))
);

// EXPORT COMPONENT

export { hoc as CallScheduleBlacklistPage };

